import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import { describeRule } from './ProtocolRuleForm.utils';
import { useFormatPhase } from './hooks/useFormatPhase';
import { Summary, SummaryTotal } from './ProtocolRuleForm.styles';

import type { Control } from 'react-hook-form';
import type { ProtocolRuleFormValues } from './ProtocolRuleForm.types';

const key = (name: string) => `adminPortal.protocols.ruleForm.summary.${name}`;

/**
 * Reads along while typing: every phase in turn as its weeks and then how often ("week 1 t/m week 4
 * 6× per week"), then the sessions over the whole rule in bold
 */
const ProtocolRuleSummary = ({
  control
}: {
  control: Control<ProtocolRuleFormValues>;
}) => {
  'use memo';
  const { t } = useTranslation('common');
  const phases = useWatch({ control, name: 'phases' });
  const description = describeRule(phases);

  const describePhase = useFormatPhase();

  return (
    <Summary complete={!!description} data-testid="protocol-rule-summary">
      {description ? (
        <Typography variant="body2">
          {`${description.phases.map(describePhase).join(', ')} — `}
          <SummaryTotal>
            {t(key('totalSessions'), { count: description.total })}
          </SummaryTotal>
        </Typography>
      ) : (
        <Typography variant="body2">{t(key('empty'))}</Typography>
      )}
    </Summary>
  );
};

export default ProtocolRuleSummary;
